import { FC } from 'react';
import { IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { NavigationMenuToggle } from '../navigation/NavigationMenu';
import { HeaderTabs, IHeaderTabGroup } from '../HeaderTabs';
import { SIDE_NAV_WIDTH } from '../navigation/NavConstants';
import { BeaSonarButton } from '../helper-bee/BeaSonarButton';
import { mediaMinWidth } from '../theme/utils';

const useStyles = createUseStyles({
    header: {
        borderBottom: 'var(--app-theme-border)',
        position: 'relative',

        '& > ion-toolbar': {
            color: 'white',
            '--ion-toolbar-background': 'var(--ion-color-primary)'
        }
    },
    title: {
        textAlign: 'center',
        paddingRight: 70,

        [mediaMinWidth.lg]: {
            paddingLeft: SIDE_NAV_WIDTH + 20,
        }
    },
    beaButtonWrapper: {
        position: 'absolute',
        top: 'calc(env(safe-area-inset-top, 0px) + 22px)',
        right: 22,
        zIndex: 100
    }
});

export interface IBasicHeader {
    title?: React.ReactNode;
    children?: React.ReactNode;
    tabs?: IHeaderTabGroup;
}

export const BasicHeader: FC<IBasicHeader> = ({ title, children, tabs }) => {
    const classes = useStyles();
    return (
        <IonHeader className={classes.header}>
            <IonToolbar color="primary" style={{paddingLeft: 10, paddingRight: 10}}>
                <NavigationMenuToggle slot="start" />
                <IonTitle className={classes.title}>
                    {title}
                </IonTitle>
                {children}
            </IonToolbar>
            {tabs &&
                <HeaderTabs tabs={tabs} />
            }
            {tabs && (
                <div className={classes.beaButtonWrapper}>
                    <BeaSonarButton
                        trackingFrom="Header Button"
                        data-id="bea-header-button"
                    />
                </div>
            )}
        </IonHeader>
    );
};
